import { render } from "./InvoiceTable.vue?vue&type=template&id=52cf53d9"
import script from "./InvoiceTable.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceTable.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/start/InvoiceTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "52cf53d9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52cf53d9', __exports__)) {
    api.reload('52cf53d9', __exports__)
  }
  
  module.hot.accept("./InvoiceTable.vue?vue&type=template&id=52cf53d9", () => {
    api.rerender('52cf53d9', render)
  })

}


export default __exports__